export default "__VITE_ASSET__9be55661__"